import './services/fonts'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Amplify from '@aws-amplify/core'
import auth from '@aws-amplify/auth'
import store from './store/index'
import VueScrollTo from 'vue-scrollto'
import Vuelidate from 'vuelidate'
import ApolloClient, { InMemoryCache } from 'apollo-boost'
import { Auth, S3 } from './plugins'
import awsAmplifyConfig from './awsAmplifyConfig'
import VueApollo from 'vue-apollo'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VueProgressiveImage from 'vue-progressive-image'
import { i18n } from './services/i18n'
import Notifications from 'vue-notification'
import CountryFlag from 'vue-country-flag'
//import VueSplide from '@splidejs/vue-splide'
//import '@splidejs/splide/dist/css/themes/splide-sea-green.min.css';
import EasySlider from 'vue-easy-slider'


const nodeEnv = process.env.NODE_ENV || process.env.VUE_APP_NODE_ENV

Vue.config.productionTip = false
Vue.use(Vuelidate)
Vue.use(VueScrollTo)
Vue.use(Auth)
Vue.use(S3)
Vue.use(VueApollo)
Vue.use(Notifications)
Vue.use(CountryFlag)
//Vue.use(VueSplide)

Vue.use(EasySlider)


Vue.use(VueProgressiveImage, {
  delay: nodeEnv === 'workstation' ? 1000 : 0,
  cache: nodeEnv !== 'workstation',
  blur: 20
})

const apolloClient = new ApolloClient({
  // You should use an absolute URL here
  uri: process.env.VUE_APP_INTL_PLATFORM_API_URL,
  name: 'customer-ui',
  onError: ({ networkError }) => {
    if (networkError) {
      store.commit('setNetworkError', true)
    }
  },
  version: '1.0.0',
  cache: new InMemoryCache(),
  request: async operation => {
    try {
      const token = (await auth.currentSession()).getAccessToken().getJwtToken()
      operation.setContext({
        headers: {
          authorization: token ? `Bearer ${token}` : ''
        }
      })
    } catch (err) {
      console.log(err)
    }
  }
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.directive('focus', {
  inserted: function (el) {
    const elementToFocus = el.getElementsByTagName('input')[0] ||
      el.getElementsByTagName('textarea')[0] ||
      el
    elementToFocus.focus()
  }
})

Amplify.configure(awsAmplifyConfig())

new Vue({
  router,
  store,
  apolloProvider,
  i18n,
  render: h => h(App)
}).$mount('#app')
